import React, { useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import 'aos/dist/aos.css';
import AOS from 'aos';
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
  FaYoutube,
  FaAngleRight, 
} from 'react-icons/fa';
import ReactCountryFlag from 'react-country-flag';

const Footer = () => {
   const location = useLocation(); // ✅ INSIDE component, TOP LEVEL
  
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location.key]);
  
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: 'ease-in-out',
      disable: 'mobile',
    });
  }, []);
const logos = [
  { img: "/img/clutch PNG.png", link: "https://clutch.co/profile/securxpert-technologies" },
  { img: "/img/goodfirms PNG.png", link: "https://www.goodfirms.co/company/securxperts-technologies-pvt-ltd" },
  { img: "/img/businessfirms.png", link: "https://businessfirms.co/company/securxpert-technologies-pvt-ltd" },
  { img: "/img/msme.png", link: "https://msme.gov.in/" },
  { img: "/img/Softwareworld PNG.png", link: "https://www.softwareworld.co/" },
  { img: "/img/freelanser.jpg", link: "https://www.freelancer.in/" },
  { img: "/img/naps.png", link: "https://www.apprenticeshipindia.gov.in/" },
  { img: "/img/skillindia.jpg", link: "https://www.apprenticeshipindia.gov.in/" },
];
  const quickLinks = [
    { to: '/', label: 'Home' },
    { to: '/who-we-are', label: 'About Us' },
    { to: '/our-services', label: 'Services & Products' },
    { to: '/blogs', label: 'Blogs' },
    { to: '/careers', label: 'Careers & Benefits' },
    { to: '/terms', label: 'Terms & Conditions' },
    { to: '/contact-us', label: 'Contact Us' },
  ];

  const services = [
    { to: '/custom-software-development', label: 'Software Development Services' },
    { to: '/it-support-services', label: 'IT Consulting & Managed Services' },
    { to: '/cloud-service-providers', label: 'Cloud & Beyonds' },
    { to: '/bpo-services', label: 'Business Process Services' },
    { to: '/data-analytics-services', label: 'AI & Data Analytics Solutions' },
    { to: '/digital-marketing-services', label: 'Digital Marketing & Experience Design' },
    { to: '/ui-ux-design-services', label: 'UI/UX-Design-Services' },
    { to: '/cybersecurity-services', label: 'Cybersecurity-Services' },
  ];
  
 const socialLinks = [
  {
    key: "facebook",
    Icon: FaFacebookF,
    url: "https://www.facebook.com/profile.php?id=61576099186187",
  },
  {
    key: "instagram",
    Icon: FaInstagram,
    url: "https://www.instagram.com/securxpert",
  },
  {
    key: "linkedin",
    Icon: FaLinkedinIn,
    url: "https://www.linkedin.com/company/securxpert-technologies-pvt-ltd/posts/?feedView=all",
  },
  {
    key: "youtube",
    Icon: FaYoutube,
    url: "https://www.youtube.com/@SecurXpert",
  },
];


  const BG_COLOR = 'bg-gray-100';
  const TEXT_COLOR = 'text-gray-700';
  const HEADING_COLOR = 'text-gray-900';
  const ACCENT_COLOR = 'text-indigo-600';
   const socialBrandColors = {
  facebook: {
    bg: "bg-[#1877F2]",
    hover: "hover:bg-[#0e5fd1]",
  },
  instagram: {
    bg: "bg-gradient-to-br from-[#f09433] via-[#e6683c] to-[#dc2743]",
    hover: "hover:from-[#d9822e] hover:via-[#c55a30] hover:to-[#c41e37]",
  },
  linkedin: {
    bg: "bg-[#0A66C2]",
    hover: "hover:bg-[#004182]",
  },
  youtube: {
    bg: "bg-[#FF0000]",
    hover: "hover:bg-[#cc0000]",
  },
};


  return (
    <footer className={`${BG_COLOR} ${TEXT_COLOR} py-8 font-sans relative`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="grid grid-cols-1 gap-y-8 sm:grid-cols-2 sm:gap-y-8 lg:grid-cols-4 lg:gap-x-6">
          
          {/* Column 1: back to original position (no negative margin) */}
          <div className="lg:col-span-1" data-aos="fade-up" data-aos-delay="100">
            <div className="mb-3">
              <img 
                src="/img/LOGO.png" 
                alt="SecurXpert Technologies Logo" 
                className="h-10 object-contain"
              />
            </div>

            <p className="text-sm my-3 text-gray-600 leading-relaxed max-w-xs">
              100% Service Quality Certified Agency Satisfaction Guarantee
            </p>

            {/* WE ARE REVIEWED - IMAGE SCROLL */}
            <div className="mt-3 overflow-hidden">
              <div className="relative w-full overflow-hidden">
               

<div className="overflow-hidden">
  <div className="flex gap-8 animate-scroll w-max">
    {[...logos, ...logos].map((item, idx) => (
      <a
        key={idx}
        href={item.link}
        target="_blank"
        rel="noopener noreferrer"
        className="w-32 h-16 bg-white rounded-lg shadow-sm flex items-center justify-center hover:shadow-md transition flex-shrink-0"
      >
        <img
          src={item.img}
          alt="Review Badge"
          className="max-h-12 object-contain"
        />
      </a>
    ))}
  </div>
</div>


                <div className="flex justify-center mt-4">
                  <div className="w-32 h-24  rounded-lg  flex items-center justify-center">
                    <img
                      src="/img/ios.jpg"
                      alt="ISO Certification"
                      className="w-15 h-15 object-contain"
                    />
                  </div>
                </div>
              </div>
            </div>

           {/* Social Links – Official brand colors */}
            <div className="flex flex-wrap gap-3 mt-8">
             {socialLinks.map((item, index) => {
  const colors = socialBrandColors[item.key] ?? {
    bg: "bg-gray-700",
    hover: "hover:bg-gray-800",
  };

  return (
    <a
      key={index}
      href={item.url}
      target="_blank"
      rel="noopener noreferrer"
      className={`
        w-10 h-10 flex items-center justify-center rounded-full
        text-white transition-all duration-300
        ${colors.bg} ${colors.hover}
        hover:shadow-lg hover:scale-110
      `}
      aria-label={`Follow us on ${item.key}`}
    >
      <item.Icon className="w-5 h-5" />
    </a>
  );
})}
            </div>
          
          </div>
          
          {/* Column 2: Quick Links - heading stays, list moved left */}
          <div className="lg:ps-10 sm:col-span-1 lg:col-span-1" data-aos="fade-up" data-aos-delay="200">
            <h3 className={`font-extrabold text-sm uppercase mb-5 ${HEADING_COLOR} relative footer-heading`}>
              Quick Links
            </h3>
            <ul className="-ml-2 lg:-ml-8 space-y-1">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.to}
                    className={`flex items-center text-sm ${TEXT_COLOR} hover:${ACCENT_COLOR} transition-colors duration-200`}
                  >
                    <FaAngleRight className={`w-3 h-3 mr-2 ${ACCENT_COLOR} flex-shrink-0`} />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Services - heading stays, list moved left */}
          <div className="sm:col-span-2 lg:col-span-1" data-aos="fade-up" data-aos-delay="300">
            <h3 className={`font-extrabold text-sm uppercase mb-5 ${HEADING_COLOR} relative footer-heading`}>
              Services
            </h3>
            <ul className="-ml-2 lg:-ml-8 space-y-1">
              {services.map((service, index) => (
                <li key={index}>
                  <Link
                    to={service.to}
                    className={`flex items-start text-sm ${TEXT_COLOR} hover:${ACCENT_COLOR} transition-colors duration-200`}
                  >
                    <FaAngleRight className={`w-3 h-3 mr-2 mt-0.5 ${ACCENT_COLOR} flex-shrink-0`} />
                    {service.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Column 4: Contact Us */}
          <div className="sm:col-span-2 lg:col-span-1" data-aos="fade-up" data-aos-delay="400">
            <h3 className={`font-extrabold text-sm uppercase mb-5 ${HEADING_COLOR} relative footer-heading`}>
              Contact Us
            </h3>
            
            <div className="space-y-2">
              <div className="flex items-start">
                <div className={`p-2.5 rounded-lg ${ACCENT_COLOR} bg-indigo-100 flex-shrink-0 mr-3`}>
                  <FaPhoneAlt className="w-4 h-4" />
                </div>
                <div>
                  <span className="block text-xs uppercase text-gray-500 font-semibold mb-0.5">Phone Number</span>
                  <a href="tel:+917993256679" className={`text-sm font-bold ${HEADING_COLOR} hover:${ACCENT_COLOR}`}>
                    +91 7993256679
                  </a>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className={`p-2.5 rounded-lg ${ACCENT_COLOR} bg-indigo-100 flex-shrink-0 mr-3`}>
                  <FaEnvelope className="w-4 h-4" />
                </div>
                <div>
                  <span className="block text-xs uppercase text-gray-500 font-semibold mb-0.5">Email Address</span>
                  <a href="mailto:info@SecurXperts.com" className={`text-sm font-bold ${HEADING_COLOR} hover:${ACCENT_COLOR}`}>
                    info@SecurXperts.com
                  </a>
                </div>
              </div>

              <div className="flex items-start">
                <div className={`p-2.5 rounded-lg ${ACCENT_COLOR} bg-indigo-100 flex-shrink-0 mr-3`}>
                  {/* <FaMapMarkerAlt className="w-4 h-4" /> */}
                  <ReactCountryFlag countryCode="IN" svg style={{ width: '1.5em', height: '1.5em', borderRadius: '4px' }} />
                </div>
                <div>
                  <span className="block text-xs uppercase text-gray-500 font-semibold mb-0.5">Securxpert technologies Pvt Ltd.</span>
                  <p className="text-sm font-medium leading-relaxed text-gray-600">
                    3rd Floor, PR R One Towers, Plot No 59, DLF Rd, near Radisson Hotel, Jayabheri Enclave, Gachibowli, Hyderabad, Telangana 500032
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className={`p-2.5 rounded-lg ${ACCENT_COLOR} bg-indigo-100 flex-shrink-0 mr-3`}>
                  <ReactCountryFlag countryCode="GB" svg style={{ width: '1.5em', height: '1.5em', borderRadius: '4px' }} />
                </div>
                <div>
                  <span className="block text-xs uppercase text-gray-500 font-semibold mb-0.5">Securxpert UK Ltd.</span>
                  <p className="text-sm font-medium leading-relaxed text-gray-600">
                    194 Gulson Road, Coventry, England, CV1 2JD United Kingdom
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="mt-8 pt-5 border-t border-gray-300 text-center">
          <p className="text-sm font-light text-gray-500">
            &copy; {new Date().getFullYear()} SecurXpert Technologies Pvt Ltd. All rights reserved.
          </p>
        </div>
      </div>

      {/* Custom CSS */}
      <style jsx>{`
        .footer-heading {
          padding-bottom: 8px; 
        }
        .footer-heading::after {
          content: '';
          display: block;
          width: 40px; 
          height: 3px;
          background-color: #4f46e5;
          position: absolute;
          bottom: 0;
          left: 0;
          border-radius: 1px;
        }
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 18s linear infinite;
          width: max-content;
        }
      `}</style>
    </footer>
  );
};

export default Footer;